"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolBar = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var TranslationsDropdown_1 = require("./TranslationsDropdown");
var Search_1 = require("./Search");
var NotificationsMenu_1 = require("./NotificationsMenu");
var ManageButton_1 = require("./ManageButton");
var AccountMenu_1 = require("./AccountMenu");
var useHeaderProps_1 = require("../hooks/useHeaderProps");
var DozukiHeader_1 = require("../DozukiHeader");
var ToolBar = function () {
    var _a = (0, useHeaderProps_1.useHeaderProps)(), permissions = _a.permissions, colorSet = _a.colorSet, user = _a.user;
    var collapseManage = (0, react_1.useBreakpointValue)({ base: true, md: false, fallback: false }, { ssr: false });
    var collapseNotifications = (0, react_1.useBreakpointValue)({ base: true, sm: false, fallback: false }, { ssr: false });
    var collapseSearch = (0, react_1.useBreakpointValue)({ base: true, xs: false, fallback: false }, { ssr: false });
    var collapseTranslations = (0, react_1.useBreakpointValue)({ base: true, xs: false, fallback: false }, { ssr: false });
    return (React.createElement(react_1.Flex, { align: "center", zIndex: DozukiHeader_1.Z_INDEX, gap: 3 },
        !collapseSearch && (React.createElement(Search_1.Search, { accountMenuProps: {
                withManage: collapseManage,
                withNotifications: collapseNotifications,
            } })),
        !collapseTranslations && React.createElement(TranslationsDropdown_1.TranslationsDropdown, { displayMode: "dropdown" }),
        !collapseNotifications && React.createElement(NotificationsMenu_1.NotificationsMenu, { displayMode: "dropdown" }),
        (permissions === null || permissions === void 0 ? void 0 : permissions.canIViewDropdownManageTab) && !collapseManage && React.createElement(ManageButton_1.ManageButton, null),
        React.createElement(AccountMenu_1.AccountMenu, { withManage: collapseManage, withNotifications: collapseNotifications, withTranslations: collapseTranslations },
            React.createElement(react_1.Avatar, { size: "sm", outline: "1px solid", outlineColor: colorSet === null || colorSet === void 0 ? void 0 : colorSet.backgroundBorder, name: user === null || user === void 0 ? void 0 : user.username, src: (user === null || user === void 0 ? void 0 : user.hasCustomAvatar) ? user === null || user === void 0 ? void 0 : user.userAvatarUrl : undefined }))));
};
exports.ToolBar = ToolBar;
